import { TEXT_DEF } from './text';

export const typeBet = {
  easy: TEXT_DEF.text0152,
  basic: TEXT_DEF.text0153,
  normal: TEXT_DEF.text0154,
  high: TEXT_DEF.text0155,
};
